module.exports = __webpack_public_path__ + "static/media/sliders.c31040d6.svg";